import axios from 'axios';
import { normalizeMediaUrls } from '../utils/mediaUrl';

export const Axios = axios.create({
    baseURL: '/api/',
});

export const AxiosM = axios.create({
    baseURL: '/media/',
});

Axios.interceptors.response.use((response) => {
    response.data = normalizeMediaUrls(response.data);
    return response;
});
